import { useCartQuery } from "~~/app/composables/queries/useStoreApi";

/**
 * Zwraca numeryczny id aktywnego koszyka (CartQueryData.cartId) lub undefined.
 * useCartQuery() to TanStack useQuery — dane w `.data` (Ref<CartQueryData | undefined>).
 * Owinięte w try/catch: poza kontekstem komponentu/setupu useQuery rzuca — tracking
 * nie może psuć UX, więc fallback do undefined (most pominie id_cart).
 */
export function useCartId(): number | undefined {
  try {
    const cart = useCartQuery();
    const id = Number(cart?.data?.value?.cartId ?? 0);
    return id > 0 ? id : undefined;
  } catch {
    return undefined;
  }
}
